module.exports = __webpack_public_path__ + "media/images/flags/NF-5455f5abcccdc03652aafa95eeaa8fd3.svg";